module.exports = __webpack_public_path__ + "07_hair_gold.0c986768.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/07_hair_gold.png
// module id = I8EI
// module chunks = 0